import React, { useState, useEffect } from "react";
import jwt from "jwt-decode";
import LoginModal from "../../components/LoginModal/Index";
import UserProfile from "./UserProfile";
import AdminProfile from "./AdminProfile";

const Profile = ({ location, history, match, targetTab }) => {

    let tab = match.params.tabName || 'edit-information';
    if (targetTab !== '')
        tab = targetTab

    let pid = match.params.pid || 0
    let tPage = match.params.pageNumber || 1
    let mainCat = match.params.mainCat || 0
    let subCat = match.params.subCat || 0
    let secCat = match.params.secCat || 0
    const [status, setStatus] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [open, setOpen] = useState(false);

    const handeClose = () => {
        setOpen(false);
    };

    const handeOpen = () => {
        setOpen(true);
    };

    useEffect(() => {
        if (!localStorage.getItem("userInfo")) {
            handeOpen()
        } else {
            if (typeof localStorage.getItem("userInfo") !== "undefined"
                && typeof localStorage.getItem("userInfo") !== ""
                && typeof localStorage.getItem("userInfo") !== null) {
                if (jwt(localStorage.getItem("token")).Roles === "admin") {
                    handeClose();
                    setStatus(true);
                    setIsAdmin(true)
                } else {
                    setIsAdmin(false)
                    handeClose();
                    setStatus(true);
                }
            }
            else {
                handeOpen()
            }
        }

    }, [])

    if (status) {
        if (!isAdmin)
            return <UserProfile tab={tab} history={history} />
        else
            return <AdminProfile tab={tab} history={history} pid={pid} tPage={tPage} mainCat={mainCat} subCat={subCat} secCat={secCat} />
    } else {
        return (
            <LoginModal open={open} redirect={true} />
        );
    }

};

export default Profile;
